import { g as r } from "./_commonjsHelpers-B52_cu2H.js";
import { r as t } from "./get-C86WHrhh.js";
var o = t();
const a = /* @__PURE__ */ r(o);
export {
  a as g
};
